
export const MODULE_NAME = 'lk-profile'

export const LK_PROFILE_ROUTES = {
  LAYOUT: MODULE_NAME,
  INDEX: `${MODULE_NAME}.index`,
} as const
